import React, { useState, useEffect } from 'react';
import { 
  Grid2,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Grid,
  Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { PartnerArrowIcon } from "../../res/NewWebIcons";

const GetAllCMSCommission = () => {
  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editValues, setEditValues] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // Fetch commissions data
  useEffect(() => {
    const fetchCommissions = async () => {
        const token = sessionStorage.getItem('jwtToken');
      try {
        const response = await fetch('https://api.ipaisa.co.in/myapp/admin/getAllCmsCommissions', {
          headers: {
            'Authorization': `Bearer ${token} `
        }
        });
        
        const data = await response.json();
        if (data.body && data.body.data) {
          setCommissions(data.body.data);
        }
      } catch (error) {
        console.error('Error fetching commissions:', error);
        setSnackbar({
          open: true,
          message: 'Failed to fetch commissions',
          severity: 'error'
        });
      } finally {
        setLoading(false);
      }
    };

    fetchCommissions();
  }, []);

  // Handle edit click
  const handleEditClick = (id, currentValue) => {
    setEditingId(id);
    setEditValues({
      ...editValues,
      [id]: currentValue
    });
  };

  // Handle input change
  const handleInputChange = (id, value) => {
    setEditValues({
      ...editValues,
      [id]: value
    });
  };

  // Handle save
  const handleSave = async (id) => {
    try {
        const token = sessionStorage.getItem('jwtToken');
      const response = await fetch(`https://api.ipaisa.co.in/myapp/admin/updateCmsCommission?id=${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token} `
        },
        body: JSON.stringify({
          userPercentage: editValues[id]
        })
      });

      const data = await response.json();
      if (response.ok) {
        // Update local state
        setCommissions(commissions.map(commission => 
          commission.id === id 
            ? { ...commission, userPercentage: parseFloat(editValues[id]) } 
            : commission
        ));
        
        setEditingId(null);
        setSnackbar({
          open: true,
          message: 'Commission updated successfully!',
          severity: 'success'
        });
      } else {
        throw new Error(data.message || 'Failed to update commission');
      }
    } catch (error) {
      console.error('Error updating commission:', error);
      setSnackbar({
        open: true,
        message: error.message,
        severity: 'error'
      });
    }
  };

  // Handle cancel edit
  const handleCancelEdit = () => {
    setEditingId(null);
  };

  // Handle snackbar close
  const handleSnackbarClose = () => {
    setSnackbar({
      ...snackbar,
      open: false
    });
  };

  if (loading) {
    return (
      <Grid2 container justifyContent="center" alignItems="center" style={{ height: '200px' }}>
        <CircularProgress />
      </Grid2>
    );
  }

  return (
    <Box style={{ padding: "2rem", marginTop: "calc(3% + 56px)" }}>
        <Grid>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1%",
                    justifyContent: "start",
                  }}
                >
                  <Typography
                    color="textSecondary"
                    style={{ fontFamily: "sans-serif", fontSize: "13px" }}
                  >
                    Balance
                  </Typography>
                  <PartnerArrowIcon />
                  <Typography
                    color="textSecondary"
                    style={{ fontFamily: "sans-serif", fontSize: "13px" }}
                  >
                    CMS Commission
                  </Typography>
                </Grid>
        
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "1%",
                  }}
                >
                  <Grid>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontFamily: "sans-serif",
                        fontSize: "19px",
                        color: "#343C6A",
                      }}
                    >
                      CMS Commission
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
    <Grid style={{ marginTop: "3%" }}>
        <TableContainer 
        component={Paper}
        sx={{
            maxWidth: "100%",
            overflowX: "auto",
            borderRadius: "12px 12px 0px 0px",
            }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Biller Name</TableCell>
                <TableCell>Percentage</TableCell>
                <TableCell>User Percentage</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {commissions.map((commission) => (
                <TableRow key={commission.id}>
                  <TableCell>{commission.id}</TableCell>
                  <TableCell>{commission.billerName}</TableCell>
                  <TableCell>{commission.percentage}</TableCell>
                  <TableCell>
                    {editingId === commission.id ? (
                      <TextField
                        type="number"
                        value={editValues[commission.id] || ''}
                        onChange={(e) => handleInputChange(commission.id, e.target.value)}
                        size="small"
                      />
                    ) : (
                      commission.userPercentage
                    )}
                  </TableCell>
                  <TableCell>
                    {editingId === commission.id ? (
                      <>
                        <Button 
                          onClick={() => handleSave(commission.id)}
                          startIcon={<CheckIcon />}
                          color="success"
                          size="small"
                        >
                          Save
                        </Button>
                        <Button 
                          onClick={handleCancelEdit}
                          startIcon={<CloseIcon />}
                          color="error"
                          size="small"
                          sx={{ ml: 1 }}
                        >
                          Cancel
                        </Button>
                      </>
                    ) : (
                      <Button 
                        onClick={() => handleEditClick(commission.id, commission.userPercentage)}
                        startIcon={<EditIcon />}
                        color="primary"
                        size="small"
                      >
                        Edit
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
    </Grid>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default GetAllCMSCommission;
